export default "__VITE_ASSET__DFQjUGh$__"